import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SplitButtonModule } from '@progress/kendo-angular-buttons';
import { IconType, QPointIconModule } from '@qpoint/icons';
import { QPointLoadingSpinnerComponent } from '@qpoint/loading';

import {
  QPointToolbarSplitButtonActionComponent,
} from './toolbar-split-button-action/toolbar-split-button-action.component';

@Component({
    selector: 'qpoint-toolbar-split-button',
    templateUrl: './toolbar-split-button.component.html',
    styleUrls: ['./toolbar-split-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SplitButtonModule,
        QPointIconModule,
        CommonModule,
        QPointLoadingSpinnerComponent
    ]
})
export class QPointToolbarSplitButtonComponent
  implements AfterContentInit, AfterViewInit {
  @Output() buttonClicked = new EventEmitter<Event>();

  @ViewChild('kendoSplitButton') kendoSplitButton;
  @ContentChildren(QPointToolbarSplitButtonActionComponent) splitButtonActions: QueryList<QPointToolbarSplitButtonActionComponent>;
  @Input() disabled = false;
  @Input() active = false;
  @Input() loading = false;
  @Input() block = false;
  @Input() icon: string = null;
  @Input() iconType: IconType = null;
  @Input() btnClass: string;
  @Input() text: string;
  @Input() public qPointButtonType: 'primary' | 'secondary' = 'secondary';
  public popUpItems: any;

  constructor() {}

  ngAfterContentInit() {
    this.setPopUpItems();
    this.splitButtonActions.changes.subscribe(() => this.setPopUpItems());
  }

  ngAfterViewInit() {
    this.kendoSplitButton.wrapper.children[0].className = `btn qpoint-button btn-${this.qPointButtonType}`;
    this.kendoSplitButton.wrapper.children[1].className = `btn qpoint-button btn-${this.qPointButtonType}`;
  }

  public onClick($event) {
    if (!this.isDisabled) {
      this.buttonClicked.emit($event);
    } else {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }

  public onClose($event) {
    window.requestAnimationFrame(() =>
      this.kendoSplitButton.button.nativeElement.blur()
    );
  }

  public onOpen($event) {
    window.requestAnimationFrame(() => {
      this.kendoSplitButton.button.nativeElement.blur();
    });
  }

  private setPopUpItems() {
    this.popUpItems = this.splitButtonActions.map(item => {
      return {
        text: item.text,
        disabled: item.disabled,
        click: () => item.actionClick.emit()
      };
    });

    // if no items are given, add a default action with the same behaviour as the default button
    if (this.popUpItems.length === 0) {
      this.popUpItems.push({
        text: this.text,
        disabled: false,
        click: () => this.buttonClicked.emit()
      });
    }
  }

  get classes(): string[] {
    const classes = ['btn', 'qpoint-button'];

    if (this.btnClass) {
      classes.push(this.btnClass);
    }

    if (this.block) {
      classes.push('btn-block');
    }

    if (this.loading) {
      classes.push('btn-loading', 'disabled');
    }

    if (this.disabled) {
      classes.push('disabled');
    }

    if (this.active) {
      classes.push('active');
    }

    if (this.text) {
      classes.push('btn-with-label');
    }

    return classes;
  }

  get isDisabled() {
    return this.disabled || this.loading;
  }
}
